import React from 'react';

const Hero = () => {
   const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPortfolio = () => {
    const element = document.getElementById('portfolio');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className="hero">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center hero-content">
            <h1>Transform Your Brand with Digital Advertising</h1>
            <p className="lead">We create impactful digital advertising solutions that drive engagement, increase conversions, and elevate your brand in the competitive market.</p>
            <div className="d-flex justify-content-center gap-3">
             <button 
                className="btn btn-primary btn-lg pulse"
                onClick={scrollToServices}
              >
                Explore Services
              </button>
              <button className="btn btn-outline-light btn-lg"
              onClick={scrollToPortfolio}>View Portfolio</button>
            </div>
            <div className="mt-5 floating">
              <i className="fas fa-arrow-down fa-2x"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;